import { render, staticRenderFns } from "./BrillouinScatteringViz.vue?vue&type=template&id=6a576352&scoped=true"
import script from "./BrillouinScatteringViz.vue?vue&type=script&lang=js"
export * from "./BrillouinScatteringViz.vue?vue&type=script&lang=js"
import style0 from "./BrillouinScatteringViz.vue?vue&type=style&index=0&id=6a576352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a576352",
  null
  
)

export default component.exports